import { createSelector } from 'reselect';
import Scopes from '../constants/Scopes';
export const getScopes = state => state.auth.user.scopes;

// We want to block installs into portals that have ONLY the developer-tools parcel
// "full-crm-access" is a scope that is in the hubspot-free parcel and not the developer-tools parcel. So if it exists, then the portal has more than just developer-tools
export const getHasOnlyDevelopersParcel = createSelector([getScopes], scopes => scopes.includes(Scopes.DEVELOPER_PORTAL_ACCESS) && !scopes.includes(Scopes.FULL_CRM_ACCESS));
export const getHasIntegrationsManagementWrite = createSelector([getScopes], scopes => scopes.includes(Scopes.INTEGRATIONS_MANAGEMENT_WRITE));